import { AbstractControlOptions, AsyncValidatorFn, UntypedFormControl, ValidatorFn } from '@angular/forms';

export class MondayWebformsFormControl extends UntypedFormControl {
    public label?: string;

    /**
     * Default value for autocomplete is 'on'
     */
    public isAutocompleteOff = false;

    public constructor(
        formState?: any,
        validatorOrOpts?: ValidatorFn | ValidatorFn[] | AbstractControlOptions | null,
        asyncValidator?: AsyncValidatorFn | AsyncValidatorFn[] | null,
        label?: string,
        isAutocompleteOff?: boolean
    ) {
        super(formState, validatorOrOpts, asyncValidator);
        this.label = label;
        this.isAutocompleteOff = isAutocompleteOff ?? false;
    }
}

//TODO: implement for more generic use cases

/* export class MondayWebformsFormControl extends FormControl {
    public id: string;
    public label: string;
    public type: string;
    public name: string;
    public style: ContextFormElementStyle;
    public errorMsg: string | null;
    public visible: boolean;
    public defaultValue: string;
    public options?: DropDownOption[];
    public elements?: RadioButtonElement[];
    public acceptedFileTypes?: string;
    public maxFileSize?: string;

    public constructor(
        id: string,
        label: string,
        type: string,
        name: string,
        style: ContextFormElementStyle,
        errorMsg: string | null,
        visible: boolean,
        defaultValue: string,
        formState?: any,
        validatorOrOpts?: ValidatorFn | ValidatorFn[] | AbstractControlOptions | null,
        asyncValidator?: AsyncValidatorFn | AsyncValidatorFn[] | null
    ) {
        super(formState, validatorOrOpts, asyncValidator);
        this.id = id;
        this.label = label;
        this.type = type;
        this.name = name;
        this.style = style;
        this.errorMsg = errorMsg;
        this.visible = visible;
        this.defaultValue = defaultValue;
    }
}

export class MondayWebFormsFormGroup extends FormGroup {
    public id: string;
    public name: string;
    public rows?: RowFormData[];
    public backText?: string;
    public nextText?: string;

    public constructor(
        id: string,
        name: string,
        controls: {
            [key: string]: AbstractControl;
        },
        validatorOrOpts?: ValidatorFn | ValidatorFn[] | AbstractControlOptions | null,
        asyncValidator?: AsyncValidatorFn | AsyncValidatorFn[] | null
    ) {
        super(controls, validatorOrOpts, asyncValidator);
        this.id = id;
        this.name = name;
    }
} */
